module.exports = __webpack_public_path__ + "img/Homegray.c39b66c6.svg";